var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-3xl mx-auto" }, [
    _c(
      "div",
      { staticClass: "mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" },
      [
        _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
          _vm._m(0),
          _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
            _c("form", [
              _c(
                "fieldset",
                [
                  _c(
                    "legend",
                    {
                      staticClass:
                        "text-base leading-6 font-medium text-gray-900"
                    },
                    [_vm._v(" Users ")]
                  ),
                  _vm._l(_vm.users, function(user, index) {
                    return _c("div", { key: index, staticClass: "mt-4" }, [
                      _c("div", { staticClass: "flex items-start" }, [
                        _c("div", { staticClass: "flex items-center h-5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: user.emailNotification,
                                expression: "user.emailNotification"
                              }
                            ],
                            staticClass:
                              "form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out",
                            attrs: { id: "pref_" + index, type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(user.emailNotification)
                                ? _vm._i(user.emailNotification, null) > -1
                                : user.emailNotification
                            },
                            on: {
                              input: function($event) {
                                return _vm.changeNotificationSetting(user)
                              },
                              change: function($event) {
                                var $$a = user.emailNotification,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        user,
                                        "emailNotification",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        user,
                                        "emailNotification",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(user, "emailNotification", $$c)
                                }
                              }
                            }
                          })
                        ]),
                        _c("div", { staticClass: "ml-3 text-sm leading-5" }, [
                          _c(
                            "label",
                            {
                              staticClass: "font-medium text-gray-700",
                              attrs: { for: "pref_" + index }
                            },
                            [_vm._v(_vm._s(user.email))]
                          )
                        ])
                      ])
                    ])
                  })
                ],
                2
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("h3", { staticClass: "text-lg font-medium leading-6 text-gray-900" }, [
        _vm._v(" Email notifications ")
      ]),
      _c("p", { staticClass: "mt-1 text-sm leading-5 text-gray-500" }, [
        _vm._v(" Subscribe for abandoned carts alerts through emails ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }